import React from 'react';

interface IProps {
  type?: 'success' | 'error' | 'copy';
  style?: React.CSSProperties;
  cbFunction: VoidFunction;
}

export const Button: React.FC<IProps> = ({ children, type, cbFunction, style }) => (
  <button className={`button button--${type}`} onClick={cbFunction} style={style}>
    {children}
  </button>
);
